import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SkeletonComponent implements OnInit {
  @Input() className: string = '';
  @Input() extraClassName: string = '';

  cssVariables: { [key: string]: string } = {};

  private readonly PROP_MAP: Record<string, string> = {
    h: 'height',
    w: 'width',
    r: 'border-radius',
    ar: 'aspect-ratio'
  };

  private readonly COLOR_MAP: Record<string, string> = {
    'c-bgt': 'var(--configBgTextColor)',
    'c-post': 'var(--configPostTextColor)',
    'c-sbg': 'var(--configSecondaryBgColor)',
    'c-bg': 'var(--configBgColor)'
  };

  ngOnInit() {
    this.cssVariables = {
      '--skeleton-height': 'auto',
      '--skeleton-width': 'auto',
      '--skeleton-border-radius': '0',
      '--skeleton-bg-color': 'var(--configPostTextColor)',
      '--skeleton-aspect-ratio': 'auto'
    };

    if (!this.className) return;

    for (const cls of this.className.trim().split(/\s+/)) {
      if (cls === 'hard') {
        this.cssVariables['--skeleton-animation'] = 'none';
        this.cssVariables['--skeleton-opacity'] = '1';
        continue;
      }

      const isMd = cls.startsWith('md:');
      const base = isMd ? cls.substring(3) : cls;
      const suffix = isMd ? '-md' : '';

      const aspectMatch = base.match(/^ar-(\d+)\/(\d+)$/);
      if (aspectMatch) {
        this.cssVariables[`--skeleton-aspect-ratio${suffix}`] = `${aspectMatch[1]} / ${aspectMatch[2]}`;
        continue;
      }

      const dimMatch = base.match(/^([hwr])-(\d+)(%?)$/);
      if (dimMatch) {
        const prop = this.PROP_MAP[dimMatch[1]];
        const unit = dimMatch[3] || 'px';
        this.cssVariables[`--skeleton-${prop}${suffix}`] = `${dimMatch[2]}${unit}`;
        continue;
      }

      const color = this.COLOR_MAP[base];
      if (color) {
        this.cssVariables[`--skeleton-bg-color${suffix}`] = color;
      }
    }
  }
}
